<template>
    <div class="projects">
        <div class="heading4">Projects</div>
        <div class="area">
            <div class="card">
                <div class="card-content">
                    <div class="card-heading">
                        Sample Projects
                    </div>
                    <div class="card-subheading">
                        Have a look at some projects I made demonstrating use of various Languages, Frameworks and Tools.
                    </div>
                    <router-link to="/sample-projects" class="button-link2 code-button">VIEW PROJECTS</router-link>
                    <img src="../assets/icons/layout.svg" class="tiny-icon">
                </div>
            </div>
        </div>
    </div>
</template>
<style scoped>
.tiny-icon{
    margin-top:5rem;
    margin-bottom:2rem;
}

.code-button:hover{
    color:var(--blue);
}

.card{
    margin-top:2rem;
    padding-top:1.6rem;
    min-height:15rem;
    background: var(--projects), var(--blue);
    background-size:cover;
    background-blend-mode: hard-light;
    
}

.card-heading{
    font-size:1.7rem;
}
    .projects{
        padding:2rem;
    }

    @media (max-width: 768px){
    .card{
        padding-top:1.2rem;
        border-radius: var(--radius);
    }

    .card-subheading{
        text-align: center;
    }
    .projects{
        padding:1rem;
    }
}

@media (max-width: 950px){
    .card{
        padding-left:1.6rem;
        padding-right:1.6rem;
    }
}
</style>